import React from 'react' // eslint-disable-line no-unused-vars
import PropTypes from 'prop-types'
import '../css/elements/widget.css'
const Widget = ({ title, description, children }) =>
  <div className='widget'>
    <div className='row'>
      <div className='col'>
        <div className='title'>{title}</div>
        <div
          className='description'
          dangerouslySetInnerHTML={{ __html: description }}
        />
      </div>
    </div>
    <div className='row'>
      <div className='col'>
        {children}
      </div>
    </div>
  </div>

Widget.propTypes = {
  // title: PropTypes.string.isRequired,
  // description: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.array,
    PropTypes.string
  ])
}

export default Widget



// WEBPACK FOOTER //
// ./src/elements/Widget.js